import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetMerchantBlackListReasonHistoryRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  filters?: Array<{
    field?: string;
    values?: Array<string>;
    valueType?: number;
    operationType?: number;
  }>;
};

export type MerchantBlackListReasonHistoryItem = {
  id?: number;
  merchantId?: number;
  merchantName?: string;
  blackListReason?: string;
  merchantStatusType?: string;
  createDate?: string;
  createUserName?: string;
};

export type GetMerchantBlackListReasonHistoryResponse = BasePagingResponse<Array<MerchantBlackListReasonHistoryItem>>;

async function getMerchantBlackListReasonHistory(
  data: GetMerchantBlackListReasonHistoryRequest
): Promise<GetMerchantBlackListReasonHistoryResponse> {
  try {
    
    const response = await axiosInstance.post("/Merchant/GetMerchantBlackListReasonHistory", data);
    
    if (response.status === 204 || !response.data) {
      return {
        data: {
          result: [],
          totalItems: 0,
          totalPages: 0,
          currentPage: data.page || 0,
          pageSize: data.size || 25,
          orderBy: data.orderBy || 'CreateDate',
          orderByDesc: data.orderByDesc || true
        },
        isSuccess: true,
        message: 'No data found',
        errorCode: null,
        requestId: ''
      };
    }
    
    return response.data;
  } catch (ex) {
    console.error('API Error:', ex);
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantBlackListReasonHistory() {
  return useMutation<GetMerchantBlackListReasonHistoryResponse, Error, GetMerchantBlackListReasonHistoryRequest>(
    (variables) => getMerchantBlackListReasonHistory(variables)
  );
}